module.exports = __webpack_public_path__ + "img/dummy-pic.2192cb48.png";